<template>
<div class="conteudo-sistema">
    <div class="fl-cabecalho">
        <div class="row animated slideInDown">
            <div class="col-12 form-group">
                <h4 class="animated slideInDown"><fa-icon icon="star" />
					Privilégios
                </h4>
            </div>
        </div>

		<div class="row animated slideInDown">
			<div class="col-lg-4 col-9 col-xs-9 form-group">
				<flFind @key-up="(inputText) => $refs.table.filtraLista(inputText)"
						placeholder="Buscar"/>
			</div>
		</div>
    </div>

    <flCarregando style="margin-top:20px" v-if="load" />

	<fl-table 	v-show="!load"
				ref="table"
				class="animated fadeIn fast"
				:perPage="40"
				columnStartSortable="id"
				:columns="geraCabecalhos()" />
</div>
</template>

<script>
import flTable from '../../../components/table/main.vue'
import flCarregando from '../../../components/carregando/main.vue'
import _ from 'lodash'
import axios from '../../../routers/axios'
import flFind from '../../../components/find/main.vue'
export default {

	components: {
		flTable,
		flCarregando,
		flFind
	},

    data(){
        return {
            load: false,
			modulos: [],
        }
    },

    mounted () {
        this.carregaDados()
    },

    methods: {

		geraCabecalhos(){

			let columns = []

			columns.push({
				name: 'Código',
				key: 'id',
				searchable: true,
				sortable: true,
				class: '',
				width: '5%',
			})

			columns.push({
				name: 'Módulo',
				key: 'nomeModulo',
				searchable: true,
				sortable: true,
				class: '',
				width: '10%',
			})

			columns.push({
				name: 'Descrição',
				key: 'descricao',
				searchable: true,
				sortable: true,
				class: '',
				width: '20%',
			})

			return columns
		},

        carregaDados(){

            this.load = true

            axios.get(this._getUrl('api/modulo')).then(response => {
                this.modulos = response.data

				axios.get(this._getUrl('api/privilegio')).then(response => {

					this.load = false
					response.data = response.data.map(item => {
						let modulo = _.find(this.modulos, o => {return item.idModuloSistema  == o.id})
						item.nomeModulo = modulo.descricao
						item._modulo = modulo

						return item
					})

					let list = response.data.map(item => { return this.geraColunas(item) })

					this.$refs.table.loadTable(list)
				})
            })
		},

		geraColunas(item){

			let itemLista = {}
			let columns = []

			// id
			columns.push({
				html : item.id,
			})

			// modulo
			columns.push({value: item.nomeModulo })

			// descricao
			columns.push({value: item.descricao })

			itemLista._object = item
			itemLista.columns = columns
			return itemLista
		},
    },
}
</script>



// WEBPACK FOOTER //
// src/views/adm/privilegio/main.vue